export const ENaturezaDocumentacao = {
  CPF: '0',
  CNPJ_MATRIZ: '1',
  CNPJ_FILIAL: '2',
};
